// Variable global para almacenar la función de logout
// Esto permite que el interceptor de axios pueda llamar al logout
let globalLogoutHandler = null

/**
 * Registra el handler de logout para que pueda ser llamado desde el interceptor de axios
 * @param {Function} logoutHandler - Función de logout del AuthContext
 */
export const registerLogoutHandler = (logoutHandler) => {
  globalLogoutHandler = logoutHandler
}

/**
 * Limpia el handler de logout
 */
export const unregisterLogoutHandler = () => {
  globalLogoutHandler = null
}

/**
 * Función para manejar la expiración del token
 * Llamada desde el interceptor de axios cuando detecta un error 401
 */
export const handleTokenExpiration = () => {
  if (globalLogoutHandler) {
    globalLogoutHandler()
  }
}

